import React from "react"
import { Main, Wrapper, IconsBox, IconsBar } from "./style"
import shieldIcon from "../../../images/shield-icon.png"
import messageIcon from "../../../images/message-icon.png"
import calendarIcon from "../../../images/calendar-icon.png"
import usersIcon from "../../../images/users-icon.png"

const SecondSection = ({ icon1, icon2, icon3, icon4 }) => {
  return (
    <Main>
      <Wrapper>
        <IconsBar>
          <IconsBox>
            <img src={shieldIcon} alt="icon" />
            <p>{icon1}</p>
          </IconsBox>
          <IconsBox>
            <img src={messageIcon} alt="icon" />
            <p>{icon2}</p>
          </IconsBox>
          <IconsBox>
            <img src={calendarIcon} alt="icon" />
            <p>{icon3}</p>
          </IconsBox>
          <IconsBox>
            <img src={usersIcon} alt="icon" />
            <p>{icon4}</p>
          </IconsBox>
        </IconsBar>
      </Wrapper>
    </Main>
  )
}

export default SecondSection
